import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { catchError, map, of } from 'rxjs';

import { AuthService } from '@services/auth/auth.service';
import { ToastService } from '@services/components/ToastService/toast.service';
import { LOGIN_ROUTE } from '@shared/constants/routes.constants';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const auth = inject(AuthService);
  const toastService = inject(ToastService);

  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  if (auth.isAuthenticated()) {
    return true;
  }

  return auth.loadCurrentUser().pipe(
    map((user) => {
      if (user) {
        return true;
      }
      router.navigateByUrl(LOGIN_ROUTE);
      return false;
    }),
    catchError(() => {
      toastService.open({
        id: 0,
        open: true,
        type: 'error',
        title: 'Error de conexión',
        description: 'No se pudo verificar tu sesión. Intenta de nuevo.',
        showIcon: true,
      });
      router.navigateByUrl(LOGIN_ROUTE);
      return of(false);
    }),
  );
};
